module.exports = __webpack_public_path__ + "static/media/workplace_logo.a2d6d27b.svg";